import pageSection from './pageSection'

export default pageSection



// WEBPACK FOOTER //
// ./client/pages/home/pageSection/index.tsx